// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"66671cb5","186":"313e8eaf","215":"0ae40083","372":"3721d62e","630":"55c52389","743":"e13743ed","841":"12444170","851":"5197eb4a","856":"6b542ccb","858":"089b1068"}[chunkId] + ".chunk.js";
};